// src/services/deploymentApi.ts — Deployment related API endpoints
import { apiClient } from './apiClient';
import type { Deployment, SecretScanFinding, SecretScanReview } from '../types';

export const deploymentApi = {
    // DEPLOYMENTS
    createDeployment: (serviceId: string | number): Promise<Deployment> => apiClient.post('/deployments', { serviceId }),
    getDeploymentLogs: (id: number): Promise<{ logs: string }> => apiClient.get(`/deployments/${id}/logs`),
    getServiceDeployments: (serviceId: string | number): Promise<Deployment[]> => apiClient.get(`/services/${serviceId}/deployments`),
    getAllDeployments: (): Promise<Deployment[]> => apiClient.get('/deployments'),
    rollbackDeployment: (deploymentId: number): Promise<{ message: string, newContainerId: string }> => apiClient.post(`/deployments/${deploymentId}/rollback`, {}),

    // SECRET SCAN REVIEWS — per-finding decisions; scanning itself cannot be disabled
    getSecretScanReviews: (serviceId: string | number): Promise<{ reviews: SecretScanReview[] }> =>
        apiClient.get(`/services/${serviceId}/secret-scan/reviews`),
    reviewSecretScanFindings: (
        serviceId: string | number,
        body: {
            deploymentId: number;
            decision: 'acknowledged' | 'false_positive';
            reason?: string;
            findings: Pick<SecretScanFinding, 'scope' | 'ruleId' | 'file' | 'fingerprint'>[];
        },
    ): Promise<{ recorded: number; rejected: unknown[] }> =>
        apiClient.post(`/services/${serviceId}/secret-scan/reviews`, body),
    revokeSecretScanReview: (serviceId: string | number, reviewId: number): Promise<{ success: boolean }> =>
        apiClient.del(`/services/${serviceId}/secret-scan/reviews/${reviewId}`),
};
